import React from 'react';
import { Card } from './ui/card';

const Contact = () => {
  return (
    <section className="contact-section-new" id="contact">
      <div className="container">
        <h2 className="section-title-center">Join The Movement</h2>
        <p className="section-subtitle-center">
          Let's connect! Reach out to us and be part of The Nick & JJ Show community!
        </p>
        
        <div className="contact-cards-grid">
          {/* Email Card */}
          <Card className="contact-info-card email-card">
            <div className="contact-card-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="64" height="64">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="contact-card-title">Email Us</h3>
            <a href="mailto:nickandjjshow@gmail.com" className="contact-card-link">
              nickandjjshow@gmail.com
            </a>
            <p className="contact-card-description">
              Drop us an email for sponsorship opportunities, bookings, or just to say hi!
            </p>
          </Card>

          {/* Phone Card */}
          <Card className="contact-info-card phone-card">
            <div className="contact-card-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="64" height="64">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <h3 className="contact-card-title">Call Us</h3>
            <a href="tel:404-740-7835" className="contact-card-link">
              404-740-7835
            </a>
            <p className="contact-card-description">
              Give us a call! We'd love to hear from you and answer your questions.
            </p>
          </Card>
        </div>

        {/* Social Media Section */}
        <div className="social-media-section">
          <h3 className="social-heading">Follow Our Journey!</h3>
          <p className="social-subheading">
            Stay connected with us on social media for updates, behind-the-scenes content, and more!
          </p>
          <div className="social-icons-large">
            <a href="https://Instagram.com/NickAndJJShow" target="_blank" rel="noopener noreferrer" className="social-icon-large instagram">
              <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Instagram</span>
            </a>
            
            <a href="https://www.youtube.com/@NickAndJJShow" target="_blank" rel="noopener noreferrer" className="social-icon-large youtube">
              <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              <span>YouTube</span>
            </a>
            
            <a href="https://www.tiktok.com/@nickandjjshow" target="_blank" rel="noopener noreferrer" className="social-icon-large tiktok">
              <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
              <span>TikTok</span>
            </a>
            
            <a href="https://www.facebook.com/profile.php?id=61572198256845" target="_blank" rel="noopener noreferrer" className="social-icon-large facebook">
              <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <span>Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
